import config from '@/config'

export default {
  combine: {
    confirm_password: "पासवर्ड पुष्टि गर्नुहोस्",
    change_password: "पासवर्ड परिवर्तन गर्नुहोस्",
    old_password: "ओल्ड @: यूआई.पासवर्ड",
    new_password: "@:ui.new @:ui.password",
    confirm_security_code: "कन्फर्म @:ui.security_code",
    first_time_login: "फर्स्ट टाइम लॉगिन",
    security_authentication: "सुरक्षा प्रमाणीकरण",
    update_security: "अद्यावधिक सुरक्षा",
    disable_security: "सुरक्षा अक्षम पार्नुहोस्",
    add_account: "खाता थप्नुहोस्",
    add_sub_account: "उप खाता थप्नुहोस्",
    edit_operator: "अपरेटर सम्पादन गर्नुहोस्",
    edit_account: "खाता सम्पादन गर्नुहोस्",
    edit_member: "सदस्य सम्पादन गर्नुहोस्",
    approve_ticket: "अनुमोदन टिकट",
    reject_ticket: "टिकट अस्वीकार गर्नुहोस्",
    add_bank_account: "बैंक खाता थप्नुहोस्",
    edit_bank_account: "बैंक खाता सम्पादन गर्नुहोस्",
    reset_threshold: "थ्रेसहोल्ड रिसेट गर्नुहोस्",
    adjust_balance: "सन्तुलन मिलाउनुहोस्",
    adjust_member: "सदस्य समायोजन गर्नुहोस्",
    configure_bank_setting: "बैंक सेटिङ कन्फिगर गर्नुहोस्",
    account_setup: "खाता सेटअप",
    bank_transfer: "बैंक स्थानान्तरण",
    edit_bank_member: "बैंक सदस्य सम्पादन गर्नुहोस्",
    edit_ticket: "टिकट सम्पादन गर्नुहोस्",
    edit_vip: "वीआईपी सम्पादन गर्नुहोस्",
    knock_off_promo: "नॉक ऑफ प्रोमोशन",
    edit_authority: "प्राधिकरण सम्पादन गर्नुहोस्",
    reset_password: "पासवर्ड रिसेट गर्नुहोस्",
    update_password: "पासवर्ड अद्यावधिक गर्नुहोस्",
    member_summary: "सदस्य सारांश",
    reply_review: "रिप्लाई रिव्यू",
    edit_affiliate: "एजेन्ट सम्पादन गर्नुहोस्",
    edit_bank_affiliate: "बैंक एजेन्ट सम्पादन गर्नुहोस्",
    approve_affiliate_tickett: "एजेण्ट टिकट स्वीकृत गर्नुहोस्",
    check_free_spin: "नि: शुल्क स्पिन जाँच गर्नुहोस्",
    reject_affiliate_ticket: "एजेंट टिकट अस्वीकार करें",
    wallet_adjust: "वालेट एडजस्ट",
    update_comm_package: "अद्यावधिक कम प्याकेज",
    approve_affiliate: "अभिकर्तालाई अनुमोदन गर्नुहोस् ",
    sub_acc_detail_affiliate: "उप खाता विवरण एजेन्ट",
    get_tac: "प्राप्त ओटीपी",
    add_coupon: "कूपन थप्नुहोस्",
    update_coupon: "अद्यावधिक कूपन",
    issue_free_spin: "मुद्दा नि: शुल्क स्पिन",
    get_bank_tac: "बैंक ओटीपी प्राप्त करें",
    update_global_setting: "अपडेट ग्लोबल सेटिंग",
    add_platform: "प्लेटफर्म थप्नुहोस्",
    edit_platform: "प्लेटफर्म सम्पादन गर्नुहोस्",
    add_bank_group: "बैंक समूह थप्नुहोस्",
    edit_bank_group: "बैंक समूह सम्पादन गर्नुहोस्",
    update_maintenance_schedule: "रखरखाव अनुसूची अद्यावधिक गर्नुहोस्",
    add_withdrawal_limit: "निकासी सीमा थप्नुहोस्",
    edit_withdrawal_limit: "निकासी सीमा सम्पादन गर्नुहोस्",
    add_campaign: "अभियान थप्नुहोस्",
    edit_campaign: "अभियान सम्पादन गर्नुहोस्",
    add_promo_group: "पदोन्नति समूह थप्नुहोस्",
    edit_promo_group: "पदोन्नति समूह सम्पादन गर्नुहोस्",
    update_team: "अद्यावधिक टोली",
    update_result: "अद्यावधिक परिणाम",
    insert_result: "परिणाम घुसाउनुहोस्",
    bet_list: "शर्त सूची",
    result_list: "परिणाम सूची",
    add_promo: "पदोन्नति थप्नुहोस्",
    raise_deposit_ticket: "डिपोजिट टिकट बढाउनुहोस्",
    bank_adjust: "बैंक समायोजन",
    promo_member_assign: "पदोन्नति सदस्य असाइन",
    bonus_issue: "बोनस मुद्दा",
    update_vip: "वीआईपी अपडेट करें",
    update_member_profile: "अद्यावधिक सदस्य प्रोफाइल",
    change_withdrawal_limit: "निकासी सीमा परिवर्तन गर्नुहोस्",
    change_bank_group: "चेन्ज बैंक ग्रुप",
    change_promotion_group: "चेन्ज प्रोमोसन ग्रुप",
    edit_promo_signup: "पदोन्नति साइनअप सम्पादन गर्नुहोस्",
    update_provider_bet_limit: "अद्यतन प्रदाता शर्त सीमा",
    update_bet_limit: "अद्यतन शर्त सीमा",
    update_member_bet_limit: "अद्यावधिक सदस्य शर्त सीमा",
    edit_bank_account_group: "बैंक खाता समूह सम्पादन गर्नुहोस्",
    redeposit_ticket: "रिडपोजिट टिकट",
    edit_promotion_group: "पदोन्नति समूह सम्पादन गर्नुहोस्",
    edit_promotion_group_norm: "समूहमा पदोन्नति व्यवस्थापन गर्नुहोस्",
    get_inbox_list: "इनबक्स सूची प्राप्त गर्नुहोस्",
    view_result_changes_detail: "परिणाम परिवर्तन विवरण हेर्नुहोस्",
    edit_promotion_signup: "पदोन्नति साइनअप सम्पादन गर्नुहोस्",
    edit_bet_limit: "बेट सीमा सम्पादन गर्नुहोस्",
    edit_provider_game_off: "प्रदाता गेम अफ सम्पादन गर्नुहोस्",
    edit_provider_rtp: "प्रदाता आरटीपी सम्पादन गर्नुहोस्",
    get_rebate: "छूट प्राप्त करें",
    get_recent_deposit: "हाल ही में जमा करें",
    add_survey: "सर्वेक्षण थप्नुहोस्",
    add_announcement_banner: "घोषणा ब्यानर थप्नुहोस्",
    edit_announcement_banner: "घोषणा ब्यानर सम्पादन गर्नुहोस्",
    move_announcement_banner: "घोषणा ब्यानर सार्नुहोस्",
    add_promotion_banner: "प्रोमोशन ब्यानर थप्नुहोस्",
    edit_promotion_banner: "पदोन्नति ब्यानर सम्पादन गर्नुहोस्",
    unlink_banner: "लिंक हटाउनुहोस्",
    move_promotion_banner: "मूव प्रोमोशन बैनर",
    add_slide_banner: "स्लाइड ब्यानर थप्नुहोस्",
    edit_slide_banner: "स्लाइड ब्यानर सम्पादन गर्नुहोस्",
    move_slide_banner: "स्लाइड ब्यानर सार्नुहोस्",
    add_seo_page: "एसईओ पृष्ठ थप्नुहोस्",
    edit_seo_page: "एसईओ पृष्ठ सम्पादन गर्नुहोस्",
    clear_outstanding: "क्लियर आउटस्टैंडिंग",
    add_ip_whitelist: "आईपी व्हाइटलिस्ट जोड़ें",
    bonus_issue_bulk: "थोक बोनस मुद्दा",
    edit_bank_member_ewallet: "सम्पादन बैंक सदस्य (ई-वालेट)",
    redeposit: "रिडपोजिट",
    reject_approved_ticket: "स्वीकृत टिकट अस्वीकार गर्नुहोस्",
    audit_ticket: "अडिट टिकट",
    review_ticket: "समीक्षा टिकट",
    edit_promotion_group_norm_seq: "समूहमा पदोन्नति अनुक्रम व्यवस्थापन गर्नुहोस्",
    edit_promo_provider_list: "पदोन्नति प्रदायक सूची सम्पादन गर्नुहोस्",
    edit_promo_payment_option: "पदोन्नति भुक्तानी विकल्प सम्पादन गर्नुहोस्",
    edit_campaign_provider_list: "अभियान प्रदायक सूची सम्पादन गर्नुहोस्",
    update_comm: "अद्यावधिक आयोग",
    update_carry_over: "अद्यावधिक क्यारी ओभर",
    review_affiliate_ticket: "रिव्यू एजेंट टिकट",
    audit_affiliate_ticket: "अडिट एजेन्ट टिकट",
    get_tac_affiliate: "प्राप्त ओटीपी (एजेंट)",
    raise_deposit_ticket_gateway: "डिपोजिट टिकट (गेटवे) बढाउनुहोस्",
    direct_audit_ticket: "ऑडिट टिकट (प्रत्यक्ष)",
    get_rollback_detail: "रोलबैक विवरण प्राप्त करें",
    get_reject_detail: "अस्वीकार विवरण प्राप्त गर्नुहोस्",
    manual_approve_ticket: "अनुमोदन टिकट (मैनुअल)",
    add_label: "लेबल थप्नुहोस्",
    edit_label: "लेबल सम्पादन गर्नुहोस्",
    rollback_processing_ticket: "रोलबैक प्रोसेसिंग टिकट",
    update_iframe_url: "अपडेट इफ्रेम यूआरएल",
    edit_exchange_rate: "विनिमय दर सम्पादन गर्नुहोस्",
    add_vip: "वीआईपी थप्नुहोस्",
    add_turnover_tier: "टर्नओवर टियर जोड़ें",
    edit_turnover_tier: "टर्नओवर टियर सम्पादन गर्नुहोस्",
    edit_mission_reward: "मिसन पुरस्कार सम्पादन गर्नुहोस्",
    enable_mission_reward: "मिसन पुरस्कार सक्षम गर्नुहोस्",
    get_member_label_list: "सदस्य लेबल सूची",
    add_rescue_fund: "उद्धार कोष थप्नुहोस्",
    get_custom_member_list: "अनुकूल सदस्य सूची",
    get_rescue_fund_provider: "उद्धार कोष प्रदायक प्राप्त गर्नुहोस्",
    add_game_exclude: "खेल बहिष्करण थप्नुहोस्",
    delete_game_exclude: "खेल बहिष्करण मेट्नुहोस्",
    domain_custom_add_assign: "डोमेन थप्नुहोस्",
    add_domain_batch: "डोमेन थप्नुहोस् (ब्याच)",
    update_payment_provider_vip: "अद्यावधिक भुक्तानी प्रदायक वीआईपी",
    update_campaign: "अद्यावधिक अभियान",
    purchase_domain: "खरीद डोमेन",
    apply_domain: "डोमेन लागू गर्नुहोस्",
    edit_access_control: "पहुँच नियन्त्रण सम्पादन गर्नुहोस्",
    add_domain: "डोमेन थप्नुहोस्",
    operator_wallet_adjust: "अपरेटर वालेट समायोजन गर्नुहोस्",
    update_payment_provider_desc: "अद्यावधिक भुक्तानी प्रदायक विवरण",
    add_package: "@:ui.add @:ui.package",
    edit_package: "@:ui.edit @:ui.package",
    add_theme_content: "@:ui.add @:ui.theme_content",
    edit_theme_content: "@:ui.edit @:ui.theme_content",
    add_theme: "@:ui.add @:ui.theme",
    edit_theme: "@:ui.edit @:ui.theme",
    add_color: "@:ui.add @:ui.color",
    edit_color: "@:ui.edit @:ui.color",
    add_content: "@:ui.add @:ui.content",
    edit_content: "@:ui.edit @:ui.content",
    delete_content: "@:ui.delete @:ui.content",
    update_setting: "@:ui.update @:ui.setting",
    add_theme_content_group: "@:ui.add @:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit @:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add @:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit @:ui.bo_default_domain",
    update_theme: "@:ui.update @:ui.theme",
    update_menu: "@:ui.update @:ui.menu",
    update_game_menu: "@:ui.update @:ui.game_menu",
    update_special_menu: "@:ui.update @:ui.special_menu",
    update_setting_menu: "@:ui.update @:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update @:ui.operator_setting",
    add_social_account: "@:ui.add @:ui.social_account",
    edit_social_account: "@:ui.edit @:ui.social_account",
    add_site_info: "@:ui.add @:ui.site_info",
    edit_site_info: "@:ui.edit @:ui.site_info",
    add_ads: "@:ui.add @:ui.advertisement",
    edit_ads: "@:ui.edit @:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit @:ui.provider @:ui.hot_game",
    edit_provider_new_game: "@:ui.edit @:ui.provider @:ui.new_game",
    edit_provider_popular_game: "@:ui.edit @:ui.provider @:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit @:ui.provider @:ui.featured_game",
    setup_logo: "सेटअप लोगो",
    add_livechat: "@:ui.add @:ui.livechat",
    update_livechat: "@:ui.update @:ui.livechat",
    provider_pt_operator_update: "प्रदायक पीटी अपरेटर अद्यावधिक",
    provider_pt_global_update: "प्रदाता पीटी ग्लोबल अपडेट",
    payment_option_callback_update: "कॉलबैक यूआरएल अपडेट",
    change_payment_option_seq: "भुक्तानी विकल्प अनुक्रम",
    change_payment_mode_status: "भुक्तानी विकल्प स्थिति अद्यावधिक",
    change_payment_option_recommend: "भुक्तानी विकल्प सिफारिस गर्नुहोस्",
    change_payment_option_credential: "भुक्तानी विकल्प क्रेडेन्शियल",
    change_payment_option_limit: "भुक्तानी विकल्प सीमा",
    change_payment_option_vip: "भुक्तानी विकल्प वीआईपी",
    add_mini_game: "@:ui.add @:ui.mini_game",
    edit_mini_game: "@:ui.edit @:ui.mini_game",
    add_mini_game_template: "@:ui.add @:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit @:ui.mini_game_template",
    edit_reward: "@:ui.edit @:ui.reward",
    gamify_update: "@:ui.update @:ui.reward",
    add_free_game_token: "@:ui.add @:ui.free_game_token",
    add_partners: "@:ui.add @:ui.partners",
    edit_partners: "@:ui.edit @:ui.partners",
    add_leaderboard: "@:ui.add @:ui.leaderboard",
    edit_leaderboard: "@:ui.edit @:ui.leaderboard",
    add_phone: "@:ui.add @:ui.phone",
    adjust_free_balance: "Adjust Free Balance",
    edit_ai_assistant: "@:ui.edit @:ui.ai_assistant",
    change_payment_option_desc: "भुक्तानी विकल्प विवरण",
    fund_transfer_provider: "फन्ड ट्रान्सफर प्रदायक",
    manual_deposit: "म्यानुअल जमाना",
    change_linkage_desc: "लिङ्केज विवरण",
    change_linkage_risk_weight: "लिङ्केज जोखिम तौल",
    add_promo_voucher: "@:ui.add @:ui.promotion_voucher",
    edit_promotion_voucher_end_date: "@:ui.edit @:ui.promotion_voucher @:ui.end_date",
    get_voucher_custom_member_list: "भाउचर कस्टम सदस्य सूची प्राप्त गर्नुहोस्",
    redeposit_ticket_voucher: "टिकट भाउचर पुनः जम्मा",
    approve_ticket_voucher: "टिकट भाउचर स्वीकृत",
    reject_ticket_voucher: "टिकट भाउचर अस्वीकृत",
    raise_deposit_ticket_voucher: "जम्मा टिकट भाउचर सिर्जना",
    raise_deposit_ticket_voucher_gateway: "जम्मा टिकट भाउचर गेटवे सिर्जना",
    get_voucher_list: "भाउचर सूची प्राप्त गर्नुहोस्",
    get_message_list: "सन्देश सूची प्राप्त गर्नुहोस्",
    edit_free_credit: "@:ui.edit @:ui.free_credit",
    knock_off_free_credit_member: "निःशुल्क क्रेडिट सदस्य रद्द गर्नुहोस्",
    free_credit_manual_assign: "निःशुल्क क्रेडिट म्यानुअल असाइन",
    review_fcp_ticket: "निःशुल्क क्रेडिट प्रदायक टिकट समीक्षा",
    audit_fcp_ticket: "निःशुल्क क्रेडिट प्रदायक टिकट अडिट",
    reject_fcp_ticket: "निःशुल्क क्रेडिट प्रदायक टिकट अस्वीकृत",
    approve_fcp_ticket: "निःशुल्क क्रेडिट प्रदायक टिकट स्वीकृत",
    edit_trigger: "ट्रिगर सम्पादन",
    edit_trigger_status: "ट्रिगर स्थिति सम्पादन",
    adjust_voucher_balance: "भाउचर ब्यालेन्स समायोजन गर्नुहोस्",
    clear_free_credit: "फ्री क्रेडिट खाली गर्नुहोस्",
    add_deposit_tier: "जम्मा स्तर थप्नुहोस्",
    edit_deposit_tier: "जम्मा स्तर सम्पादन गर्नुहोस्",
    add_leaderboard_banner: "लीडरबोर्ड ब्यानर थप्नुहोस्",
    edit_leaderboard_banner: "लीडरबोर्ड ब्यानर सम्पादन गर्नुहोस्",
    add_referral_banner: "रेफरल ब्यानर थप्नुहोस्",
    edit_referral_banner: "रेफरल ब्यानर सम्पादन गर्नुहोस्",
    edit_vip_icon: "VIP आइकन सम्पादन गर्नुहोस्",
    add_reward_rain: "Reward Rain थप्नुहोस्",
    edit_reward_rain: "Reward Rain सम्पादन गर्नुहोस्",
    add_reward_rain_session: "Reward Rain सेसन थप्नुहोस्",
    edit_reward_rain_session: "Reward Rain सेसन सम्पादन गर्नुहोस्",
    edit_reward_rain_session_end_date: "Reward Rain सेसनको अन्त्य मिति सम्पादन गर्नुहोस्",
    add_news: "समाचार थप्नुहोस्",
    edit_news: "समाचार सम्पादन गर्नुहोस्",
  },
  short: {
    deposit_amount: "डिपोजिट रकम",
    base_amount: "आधार राशि",
    bonus_amount: "बोनस रकम",
    target_amount: "लक्ष्य रकम",
    knockoff_by: "के.ओ. बाय",
    knockoff_date: "के.ओ. डेट",
    incoming_threshold: "आवक थ्रेसहोल्ड",
    incoming_frequency: "आवक आवृत्ति",
    outgoing_threshold: "आउटगोइंग थ्रेसहोल्ड",
    outgoing_frequency: "आउटगोइंग फ्रीक्वेंसी",
    account_balance: "खाता ब्यालेन्स",
    claim_type: "दावी प्रकार",
    bonus_rate: "बोनस दर",
    max_bonus: "अधिकतम बोनस",
    rollover: "रोलओवर",
    criteria: "मापदण्ड",
    start_time: "स्टार्ट टाइम",
    end_time: "अन्त्य समय",
    monday: "सोमवार",
    tuesday: "मंगलवार",
    wednesday: "बुधवार",
    thursday: "गुरुवार",
    friday: "शुक्रवार",
    saturday: "शनिवार",
    sunday: "रविवार",
    status: "स्थिति",
    bonus_rate_percent: "बोनस दर (%)",
    valid_turnover: "वैध टर्नओवर",
    deposit_count: "डिपोजिट काउन्ट",
    withdrawal_amount: "निकासी रकम",
    withdrawal_count: "निकासी गणना",
    adjustment_amount: "समायोजन रकम",
    referee_count: "रेफरी काउंट",
    signup_count: "साइनअप काउंट",
    verified_count: "सत्यापित गणना",
    active_member: "सक्रिय सदस्य",
    ftd_count: "एफटीडी काउंट",
    ftd_amount: "एफटीडी एम्ट",
    working_date: "कार्य मिति",
    recipient_bank_id: "प्राप्तकर्ता बैंक आईडी",
    recipient_bank_acc_no: "प्राप्तकर्ता बैंक एसीसी नं।",
    recipient_bank_acc_holder: "प्राप्तकर्ता बैंक एसीसी होल्डर",
    sender_bank: "प्रेषक बैंक",
    sender_bank_acc_no: "प्रेषक बैंक एसीसी नं.",
    sender_bank_acc_holder: "प्रेषक बैंक एसीसी होल्डर",
    unique_login_count: "अद्वितीय लगइन गणना",
    unique_deposit_count: "अद्वितीय जमा गणना",
    unique_withdrawal_count: "अद्वितीय निकासी गणना",
    second_deposit_count: "दोस्रो डिपोजिट गणना",
    reject_date: "अस्वीकार मिति",
    processing_date: "प्रशोधन मिति",
    deposit_withdrawal_different: "जमा निकासी अलग",
    external_id: "बाह्य आईडी",
    draft_version: "ड्राफ्ट संस्करण",
    prod_version: "प्रोड संस्करण",
    purchased_date: "खरीद गरिएको मिति",
    completed_amount: "पूरा भएको रकम",
    min_amount: "न्यूनतम रकम",
    max_amount: "अधिकतम रकम",
    total_claimed_amount: "कुल दाबी गरिएको रकम",
  },
  date_ranges: {
    0: "आज",
    1: "कल",
    2: "यो महिना",
    4: "पिछले महीने",
  },
  langList: {
    EN: "अङ्ग्रेजी",
    CN: "चिनियाँ",
    PHP: "फिलिपिन्स",
    esp: "एस्पानोल",
    RUS: "रूसी",
    VI: "भियतनामी",
    MS: "मलाय",
    NE: "नेपाली",
    CT: "चिनियाँ (ताइवान)",
    BN: "बंगला"
  },
  menulist: {
    home: "घर",
    hot: "हॉट",
    slot_game: "स्लट",
    casino: "क्यासिनो",
    sportsbook: "स्पोर्ट्सबुक",
    fishing: "माछा मार्ने",
    lottery: "लॉटरी",
    poker: "पोकर",
    hash_game: "हैश गेम",
    sabong: "सबोंग",
    promotion: "पदोन्नति",
    review: "समीक्षा | समीक्षा",
    news: "समाचार",
    live_stream: "लाइव स्ट्रीम",
    vip: "वीआईपी",
    referral: "रेफरल",
    favourite: "मनपर्ने",
    mission: "मिशन (मिनी गेम)",
    spin: "स्पिन",
    leaderboard: "लीडरबोर्ड",
    account: "खाता",
    deposit: "डिपोजिट",
    withdrawal: "निकासी",
    bet_history: "बेट हिस्ट्री",
    pending_status: "लंबित स्थिति",
    change_password: "पासवर्ड परिवर्तन गर्नुहोस्",
    profile: "प्रोफाइल",
    banking_details: "बैंकिंग विवरण",
    inbox: "इनबक्स",
    voucher: "वाउचर",
    wallet: "वालेट",
    statement: "बयान",
    download: "डाउनलोड",
    game: "खेल",
    special: "विशेष",
    misc: "विविध",
    contact_us: "हामीलाई सम्पर्क गर्नुहोस्",
    e_sportsbook: "ई-स्पोर्ट्सबुक",
    lotto: "लोट्टो",
    p2p: "पी 2 पी",
    other: "अन्य",
    vip2: "वीआईपी 2",
    referral2: "रेफरल 2",
    event: "घटना",
    daily_reward: "दैनिक इनाम",
    play2earn: "प्ले 2 अर्न",
    redemption: "मोचन",
    card_board: "कार्ड बोर्ड",
    lobby: "लॉबी",
    in_house: "इन हाउस",
    transfer: "स्थानान्तरण",
    horse_racing: "घोडा दौड",
    register: "रजिस्टर",
    login: "लगइन",
    transaction_history: "लेनदेन इतिहास",
    bingo: "बिंगो",
    member: "सदस्य",
    arcade: "आर्केड",
    crash: "दुर्घटना",
    freeplay: "नि:शुल्क खेल",
    others: "अन्य",
  },

  ok: "ठीक छ",
  cancel: "रद्द गर्नुहोस्",
  login: "लगइन",
  logout: "लगआउट",
  add: "थप्नुहोस्",
  edit: "सम्पादन गर्नुहोस्",
  delete: "मेट्नुहोस्",
  refresh: "ताजा गर्नुहोस्",
  action: "कार्य",
  id: "आईडी",
  name: "नाम",
  all: "सब",
  search: "खोज",
  remove: "हटाउनुहोस्",
  save: "बचत गर्नुहोस्",
  account: "खाता",
  settings: "सेटिङ",
  on: "चालू",
  off: "बन्द",
  new: "नयाँ",
  clear: "स्पष्ट",
  users: "प्रयोगकर्ता | प्रयोगकर्ता",
  username: "प्रयोगकर्ता नाम",
  password: "पासवर्ड",
  created_on: "सिर्जना गर्नुहोस्",
  active: "सक्रिय",
  page_size: "पृष्ठ साइज",
  status: "स्थिति",
  result: "परिणाम",
  close: "बन्द गर्नुहोस्",
  back: "पछाडि",
  show: "देखाउनुहोस्",
  login_id: "लगइन आईडी",
  date_time: "मिति समय",
  ip_address: "आईपी ठेगाना",
  domain_name: "डोमेन नाम",
  browser_agent: "ब्राउजर एजेन्ट",
  action_by: "एक्शन बाय",
  details: "विवरण",
  key: "कुञ्जी | कुञ्जीहरू",
  value: "मूल्य | मानहरू",
  from: "बाट",
  to: "गर्न",
  type: "प्रकार",
  criteria: "मापदण्ड",
  log: "लग",
  report: "रिपोर्ट",
  security_tag: "सुरक्षा ट्याग",
  security_code: "सुरक्षा कोड",
  submit: "सबमिट",
  disable: "अक्षम पार्नुहोस्",
  operators: "अपरेटर | अपरेटरहरू",
  members: "सदस्यहरू",
  account_id: "खाता आईडी",
  confirm_password: "पासवर्ड पुष्टि गर्नुहोस्",
  full_name: "पूरा नाम",
  contact_phone: "सम्पर्क फोन",
  contact_email: "सम्पर्क ईमेल",
  dashboard: "डैशबोर्ड",
  sub_account: "उप खाता",
  authority_option: "प्राधिकरण विकल्प",
  banks: "बैंक | बैंक",
  login_ip: "लगइन आईपी",
  block: "ब्लक",
  profile_id: "प्रोफाइल आईडी",
  suspend: "निलम्बित",
  deposit: "जम्मा",
  withdrawal: "निकासी",
  bulk_withdrawal: "थोक निकासी",
  rejected: "अस्वीकृत",
  processed: "प्रोसेस्ड",
  pending: "लंबित",
  member: "सदस्य",
  amount: "राशि",
  bank_acc_no: "बैंक एसीसी नं.",
  deposit_date: "डिपोजिट मिति",
  deposit_method: "डिपोजिट विधि",
  approve: "अनुमोदन",
  reject: "अस्वीकार",
  remark: "टिप्पणी",
  ticket_detail: "टिकट विवरण",
  promo: "प्रोमो",
  package: "प्याकेज",
  created_date: "सिर्जना गरिएको मिति",
  currency: "मुद्रा",
  bank_acc_holder: "बैंक एसीसी होल्डर",
  ref_no: "रेफरी नहीं",
  vip: "भीआईपी",
  modified_date: "परिमार्जित मिति",
  modified_by: "संशोधित द्वारा",
  bank_member: "बैंक सदस्य",
  bank_operator: "बैंक अपरेटर",
  bank_name: "बैंकको नाम",
  bank_acc_type: "बैंक एसीसी प्रकार",
  account_balance: "खाता मौज्दात",
  threshold: "थ्रेसहोल्ड",
  incoming: "आवक",
  outgoing: "आउटगोइंग",
  frequency: "फ्रिक्वेन्सी",
  reset_threshold: "थ्रेसहोल्ड रिसेट गर्नुहोस्",
  adjust_balance: "मौज्दात समायोजन गर्नुहोस्",
  bank_from: "बैंक बाट",
  bank_to: "बैंक टू",
  attachment: "अनुलग्नक",
  sender_bank: "प्रेषक बैंक",
  sender_bank_acc_no: "प्रेषक बैंक खाता नम्बर",
  sender_bank_acc_holder: "प्रेषक बैंक खाता धारक",
  audit: "अडिट",
  action_status: "कार्य स्थिति",
  action_date: "कार्य मिति",
  promotion: "प्रवर्द्धन",
  promo_id: "प्रोमो आईडी",
  promo_name: "प्रोमो नाम",
  package_id: "प्याकेज आईडी",
  claim_type: "दाबी प्रकार",
  bonus_rate: "बोनस दर",
  max_bonus: "अधिकतम बोनस",
  rollover: "रोलओभर",
  start_date: "सुरु मिति",
  end_date: "अन्त्य मिति",
  adj_amount: "रकम समायोजन गर्नुहोस्",
  promotion_member: "पदोन्नति सदस्य",
  on_going: "अन गोइंग",
  knock_off: "नॉक ऑफ",
  all_ongoing: "सब चल रहा है",
  deposit_amount: "जम्मा रकम",
  base_amount: "आधार रकम",
  bonus_amount: "बोनस रकम",
  target_amount: "लक्ष्य रकम",
  claim_date: "दावी मिति",
  accumulate_win: "संचय जीत",
  accumulate_turnover: "संचित टर्नओवर",
  bonus: "बोनस",
  bonus_log: "बोनस लग",
  member_id: "सदस्य आईडी",
  before_balance: "ब्यालेन्स भन्दा पहिले",
  transfer_amount: "स्थानान्तरण रकम",
  after_balance: "ब्यालेन्स पछि",
  created_by: "द्वारा बनाई गई",
  bonus_name: "बोनस नाम",
  bonus_desc: "बोनस विवरण",
  bonus_type: "बोनस प्रकार",
  add_promo: "प्रवर्द्धन थप्नुहोस्",
  bonus_value: "बोनस मूल्य",
  attach_promo: "संलग्न पदोन्नति",
  daily_statement: "दैनिक बयान",
  working_date: "कार्यरत मिति",
  opening_balance: "ओपनिंग बैलेंस",
  turnover: "टर्नओवर",
  valid_turnover: "वैध कारोबार",
  winlose: "विनलोस",
  withdrawal_amount: "निकासी रकम",
  closing_balance: "क्लोजिंग बैलेंस",
  sub_total: "सब टोटल",
  grand_total: "ग्रैंड टोटल",
  daily_winlose: "डेली विनलोज",
  game_result_slots: "खेल परिणाम (स्लट)",
  game_result_livecasino: "गेम परिणाम (लाइवकैसिनो)",
  game_result_rebate: "गेम परिणाम (छूट)",
  game_result_sportsbook: "गेम परिणाम (स्पोर्ट्सबुक)",
  game_result_cockfight: "गेम रिजल्ट (कॉकफाइट)",
  game_result_rescue: "गेम परिणाम (बचाव)",
  game_result_others: "गेम परिणाम (अन्य)",
  bet_count: "बेट काउंट",
  result_id: "परिणाम आईडी",
  bet_time: "बेट टाइम",
  result_time: "परिणाम टाइम",
  payout: "पेआउट",
  game_type: "खेल प्रकार",
  game_name: "खेल नाम",
  game_provider: "खेल प्रदायक",
  reset: "रिसेट",
  mode: "मोड",
  balance: "ब्यालेन्स",
  min_bal_knock_off_promo: "मिन बाल (पदोन्नति को स्वत: दस्तक देने के लिए)",
  social_account: "सामाजिक खाता",
  wechat: "वीचैट",
  telegram: "टेलीग्राम",
  whatsapp: "व्हाट्सएप",
  facebook: "फेसबुक",
  instagram: "इन्स्टाग्राम",
  login_log: "लगइन लग",
  platform: "प्लेटफर्म",
  bank_statement: "बैंक स्टेटमेंट",
  transfer_date: "स्थानान्तरण मिति",
  detail: "विवरण",
  date: "मिति",
  transfer_list: "स्थानान्तरण सूची",
  credit: "क्रेडिट",
  badge: "ब्याज",
  debit: "डेबिट",
  month: "महिना",
  unblock: "अनब्लक",
  unblock_member: "अनब्लक सदस्य",
  unblock_operator: "अनब्लक अपरेटर",
  referrer_id: "रेफरर आईडी",
  referrer_code: "रेफरर कोड",
  referral_code: "रेफरल कोड",
  bonus_and_adjustment: "बोनस र समायोजन",
  adjustment: "समायोजन",
  incoming_amount_threshold: "आवक राशि थ्रेसहोल्ड",
  outgoing_amount_threshold: "आउटगोइंग राशि थ्रेसहोल्ड",
  knock_off_by: "नॉक ऑफ बाय",
  knock_off_date: "नॉक ऑफ डेट",
  total_turnover: "कुल टर्नओवर",
  total_winlose: "टोटल विनलोज",
  total_deposit: "कुल जमा",
  total_member: "कुल सदस्य",
  active_player: "सक्रिय खेलाडी",
  top_winner: "शीर्ष विजेता",
  top_loser: "टॉप लूजर",
  winner: "विजेता",
  loser: "हारेको",
  deposit_count: "जम्मा गणना",
  withdrawal_count: "निकासी गणना",
  alert: "अलर्ट",
  incoming_threshold: "आगमन थ्रेसहोल्ड",
  incoming_frequency: "आगमन आवृत्ति",
  outgoing_threshold: "प्रस्थान थ्रेसहोल्ड",
  outgoing_frequency: "प्रस्थान आवृत्ति",
  reset_password: "पासवर्ड रिसेट गर्नुहोस्",
  transfer: "स्थानान्तरण",
  company_bank: "कम्पनी बैंक",
  company_bank_acc_no: "कंपनी बैंक एसीसी नं।",
  company_bank_acc_holder: "कंपनी बैंक एसीसी होल्डर",
  registered_member: "पंजीकृत सदस्य",
  promotion_report: "पदोन्नति रिपोर्ट",
  deposited_member: "जमा सदस्य",
  referred_member: "संदर्भित सदस्य",
  validated_on: "मान्य पर",
  first_deposit: "फर्स्ट डिपॉजिट",
  reward: "इनाम",
  inbox: "इनबक्स",
  manual_bonus: "म्यानुअल बोनस",
  review: "समीक्षा",
  reviews: "समीक्षा",
  review_list: "समीक्षा सूची",
  review_detail: "समीक्षा विवरण",
  reply_review: "समीक्षामा उत्तर दिनुहोस्",
  comment: "टिप्पणी",
  reply: "उत्तर दिनुहोस्",
  recipient_no: "प्राप्तकर्ता नं।",
  question: "प्रश्न",
  rating: "रेटिंग",
  content: "सामग्री",
  image: "छवि",
  monthly_rating: "मासिक रेटिंग",
  affiliate: "एजेन्ट",
  affiliate_list: "एजेन्ट सूची",
  affiliate_code: "एजेंट कोड",
  approved_by: "द्वारा अनुमोदित",
  approved_date: "स्वीकृत मिति",
  bank_affiliate: "बैंक एजेन्ट",
  bank_id: "बैंक आईडी",
  ticket_detail_affiliate: "टिकट विवरण एजेन्ट",
  pending_application: "लंबित आवेदन",
  pending_review_withdrawal: "लंबित और समीक्षा निकासी",
  unblock_affiliate: "अनब्लक एजेन्ट",
  wallet_adjust: "वालेट समायोजन",
  comm_package: "कॉम पैकेज",
  affiliate_id: "एजेन्ट आईडी",
  sub_account_detail: "उप खाता विवरण",
  daily_winlose_affiliate: "डेली विन्लोज (एजेंट)",
  daily_deposit_affiliate: "डेली डिपॉजिट (एजेंट)",
  export_excel: "एक्सपोर्ट एक्सेल",
  get_tac: "ओटीपी प्राप्त गर्नुहोस्",
  tac_code: "ओटीपी कोड",
  expiry_date: "एक्सपायरी डेट",
  inactive: "निष्क्रिय",
  last_deposit_date: "अंतिम जमा तिथि",
  coupon: "कूपन",
  allocated: "आवंटित",
  claimed: "दावा किया",
  approved: "स्वीकृत",
  coupon_code: "कूपन कोड",
  coupon_quota: "कूपन कोटा",
  current_allocated: "वर्तमान आवंटित",
  new_allocated: "नयाँ आवंटित",
  update: "अद्यावधिक",
  copy: "प्रतिलिपि",
  bonus_rate_percent: "बोनस दर (%)",
  coupon_desc: "कूपन विवरण",
  both: "दोनों",
  issue_free_spin: "निःशुल्क स्पिन जारी गर्नुहोस्",
  game: "खेल",
  max_win_amount: "मैक्स विन राशि",
  utm_list: "यूटीएम सूची",
  search_by_member: "सदस्य द्वारा खोज",
  campaign: "अभियान",
  deposited: "जमा",
  search_by_id: "आईडी द्वारा खोज",
  get_bank_tac: "बैंक ओटीपी प्राप्त गर्नुहोस्",
  bank_statement_daily: "बैंक स्टेटमेंट (दैनिक)",
  transfer_type: "स्थानान्तरण प्रकार",
  audit_freebies_list: "ऑडिट फ्रीबी सूची",
  acknowledge: "स्वीकार गर",
  submit_acknowledgement: "अभिस्वीकृति पेश गर्नुहोस्",
  is_ack: "इज एक्क",
  yes: "हाँ",
  no: "छैन",
  audit_rescue_fund_list: "लेखापरीक्षा उद्धार कोष सूची",
  global_setting: "ग्लोबल सेटिंग",
  signup_ip: "साइनअप आईपी",
  last_login_ip: "लास्ट लगइन आईपी",
  last_login_time: "लास्ट लगइन टाइम",
  link: "लिङ्क",
  is_default: "पूर्वनिर्धारित छ",
  is_public: "सार्वजनिक छ",
  bank_group: "बैंक समूह",
  set_default: "पूर्वनिर्धारित सेट गर्नुहोस्",
  group_id: "समूह आईडी",
  group_name: "समूह नाम",
  provider_maintenance: "प्रदायक रखरखाव",
  provider_code: "प्रदायक कोड",
  provider_name: "प्रदायकको नाम",
  withdrawal_limit: "निकासी सीमा",
  limit_id: "सीमा आईडी",
  limit_name: "सीमा नाम",
  daily_amount: "दैनिक रकम",
  daily_frequency: "दैनिक आवृत्ति",
  promotion_id: "प्रोमोशन आईडी",
  promotion_name: "पदोन्नति नाम",
  withhold_bonus: "विथहोल्ड बोनस",
  withhold_amount: "विथहोल्ड रकम",
  withhold_amt: "विथहोल्ड एम्ट",
  max_withdraw_amt: "मैक्स रिफॉल एम्ट",
  max_withdraw_amount: "अधिकतम निकासी रकम",
  monday: "सोमबार",
  tuesday: "मंगलबार",
  wednesday: "बुधबार",
  thursday: "बिहीबार",
  friday: "शुक्रबार",
  saturday: "शनिबार",
  sunday: "आइतबार",
  start_time: "सुरु समय",
  end_time: "अन्त्य समय",
  day: "दिन | दिनहरू",
  coupon_status: "कूपन स्थिति",
  campaign_id: "अभियान आईडी",
  campaign_name: "अभियानको नाम",
  promotion_group: "पदोन्नति समूह",
  referee_list: "रेफ्री सूची",
  account_verified: "खाता प्रमाणित",
  verified_date: "प्रमाणित मिति",
  ticket_list: "टिकट सूची",
  vip_id: "वीआईपी आईडी",
  vip_name: "वीआईपी नाम",
  self_rebate_rate: "सेल्फ रिबेट रेट (%)",
  downline_rebate_rate: "डाउनलाइन छूट दर (%)",
  provider: "प्रदायक",
  match_id: "म्याच आईडी",
  home_team: "होम टीम",
  away_team: "अवे टीम",
  home_team_new: "होम टीम न्यू",
  away_team_new: "अवे टीम न्यू",
  updated_by: "द्वारा अपडेट गरिएको",
  updated_on: "अद्यावधिक गरिएको",
  home_score: "होम स्कोर",
  away_score: "अवे स्कोर",
  home_score_new: "होम स्कोर न्यू",
  away_score_new: "अवे स्कोर न्यू",
  team: "टीम",
  match_time: "म्याच टाइम",
  match_round: "मैच राउंड",
  home_group: "गृह समूह",
  away_group: "अवे ग्रुप",
  match: "मिलान",
  match_status: "मिलान स्थिति",
  insert: "घुसाउनुहोस्",
  pin: "पिन",
  bet_list: "बेट सूची",
  result_list: "नतिजा सूची",
  bet_id: "बेट आईडी",
  bet_home: "बेट होम",
  bet_away: "बेट अवे",
  bet_on: "बेट ऑन",
  min_deposit: "न्यूनतम डिपोजिट",
  min_withdrawal: "न्यूनतम निकासी",
  raise_deposit_ticket: "जम्मा टिकट उठाउनुहोस्",
  method: "विधि",
  one_time_depositor: "वन टाइम डिपॉजिटर",
  current_month_non_depositor: "वर्तमान माह गैर जमाकर्ता",
  current_month_no_login: "हालको महिना कुनै लगइन छैन",
  ticket_date: "टिकट मिति",
  ftd_amount: "एफटीडी रकम",
  bonus_issue: "बोनस जारी",
  promotion_summary: "पदोन्नति सारांश",
  promotion_summary_detail: "पदोन्नति सारांश (विवरण)",
  claim_frequency: "क्लेम फ्रीक्वेंसी",
  provider_list: "प्रदायक सूची",
  platform_winlose: "प्लेटफार्म विनलोज",
  adjustment_amount: "समायोजन रकम",
  referee_count: "सिफारिस गर्नेको संख्या",
  category: "श्रेणी',",
  update_vip: "भीआईपी अपडेट गर्नुहोस्",
  promotion_signup: "पदोन्नति साइनअप",
  provider_bet_limit: "प्रदाता शर्त सीमा",
  update_member_bet_limit: "सदस्य बेट सीमा अपडेट गर्नुहोस्",
  bet_limit: "शर्त सीमा",
  sports_game: "खेल / खेल",
  league_name: "लीग नाम",
  home_team_name: "होम टीम का नाम",
  away_team_name: "अवे टीम नाम",
  wl_status: "विनलोज स्थिति",
  available_bank_account: "उपलब्ध बैंक खाता",
  group_bank_account: "समूह बैंक खाता",
  edit_bank_group: "बैंक समूह सम्पादन गर्नुहोस्",
  edit_bank_account_group: "बैंक खाता समूह सम्पादन गर्नुहोस्",
  redeposit: "पुनः जम्मा गर्नुहोस्",
  upline: "अपलाइन",
  downline: "डाउनलाइन",
  available_promotion: "उपलब्ध पदोन्नति",
  group_promotion: "समूह पदोन्नति",
  edit_promotion_group: "प्रोमोशन समूह सम्पादन गर्नुहोस्",
  edit_promotion_group_norm: "समूहमा प्रोमोशन व्यवस्थापन गर्नुहोस्",
  balance_before: "पहिले ब्यालेन्स",
  balance_after: "ब्यालेन्स आफ्टर",
  signup_count: "साइनअप संख्या",
  verified_count: "प्रमाणित संख्या",
  active_member: "सक्रिय सदस्य",
  ftd_count: "एफटीडी संख्या",
  daily_summary_company: "दैनिक सारांश (कंपनी)",
  daily_summary_operator: "दैनिक सारांश (ऑपरेटर)",
  daily_summary_member: "दैनिक सारांश (सदस्य)",
  daily_ledger_operator: "दैनिक लेजर (ऑपरेटर)",
  bonus_list: "बोनस सूची",
  ltd_date: "लिमिटेड मिति",
  adjustment_log: "समायोजन लग",
  get_inbox: "इनबक्स प्राप्त गर्नुहोस्",
  is_claimed: "दावा किया गया है",
  mix_parlay: "मिक्स पार्ले",
  event: "कार्यक्रम",
  result_changes_log: "परिणाम परिवर्तन लग",
  view_detail: "विवरण हेर्नुहोस्",
  total_referee: "कुल रेफरी",
  verified_signup: "प्रमाणित / साइनअप",
  ftd: "एफटीडी | फर्स्ट टाइम डिपॉजिट",
  raw_msg: "कच्चा सन्देश",
  unselect_all: "सबै चयन नगर्नुहोस्",
  select_all: "सबै चयन गर्नुहोस्",
  edit_bet_limit: "बेट सीमा सम्पादन गर्नुहोस्",
  provider_game_off: "प्रदाता गेम ऑफ",
  provider_hot_game: "प्रदाता गर्म खेल",
  game_id: "गेम आईडी",
  game_list: "खेल सूची",
  off_list: "सूची बन्द",
  provider_rtp: "प्रदाता आरटीपी",
  rtp: "आरटीपी",
  signup_date: "साइनअप मिति",
  free_credit: "नि: शुल्क क्रेडिट",
  downline_rebate: "डाउनलाइन छूट",
  game_rebate: "गेम रिबेट",
  rebate: "छूट",
  ftd_date: "एफटीडी तिथि",
  provider_winlose_company: "प्रदाता विनलोस (कंपनी)",
  provider_winlose_operator: "प्रदाता विनलोज (ऑपरेटर)",
  already_hit: "पहले से ही हिट",
  ongoing: "चालु",
  members_export: "सदस्य (निर्यात)",
  get_recent_deposit: "हालको जम्मा प्राप्त गर्नुहोस्",
  recent_deposit: "हालको डिपोजिट",
  survey_list: "सर्वेक्षण सूची",
  modified_on: "परिमार्जित",
  cms: "सीएमएस",
  announcement_banner: "घोषणा बैनर",
  promotion_banner: "प्रोमोशन बैनर",
  slide_banner: "स्लाइड बैनर",
  seo_page: "एसईओ पृष्ठ",
  en_title: "शीर्षक (ईएन)",
  cn_title: "शीर्षक (सीएन)",
  local_title: "शीर्षक (स्थानीय)",
  en_img: "छवि (ईएन)",
  cn_img: "छवि (सीएन)",
  local_img: "छवि (स्थानीय)",
  before_login: "लगइन अघि",
  after_login: "लगइन पछि",
  en: "ईएन",
  move_up: "मूव अप",
  move_down: "मूव डाउन",
  banner_type: "ब्यानर प्रकार",
  default_order: "पूर्वनिर्धारित क्रम",
  item_order: "आइटम अर्डर",
  title: "शीर्षक",
  banner_id: "ब्यानर आईडी",
  order: "आदेश",
  body: "शरीर",
  en_image: "छवि (ईएन)",
  local_image: "छवि (स्थानीय)",
  move: "सार्नुहोस्",
  en_img_desktop: "छवि डेस्कटप (ईएन)",
  cn_img_desktop: "छवि डेस्कटप (सीएन)",
  local_img_desktop: "छवि डेस्कटप (स्थानीय)",
  en_img_mobile: "इमेज मोबाइल (ईएन)",
  cn_img_mobile: "इमेज मोबाइल (सीएन)",
  local_img_mobile: "छवि मोबाइल (स्थानीय)",
  login_required: "लगइन आवश्यक",
  new_window_tab: "नयाँ सञ्झ्याल / ट्याब",
  current_page: "हालको पृष्ठ",
  target: "लक्ष्य",
  event_filter: "इभेन्ट फिल्टर",
  alt: "अल्ट",
  href: "ह्रेफ",
  image_desktop: "डेस्कटप छवि",
  image_mobile: "मोबाइल छवि",
  en_alt: "अल्ट (ईएन)",
  local_alt: "अल्ट (स्थानीय)",
  en_href: "ह्रेफ (ईएन)",
  local_href: "ह्रेफ (स्थानीय)",
  en_image_desktop: "डेस्कटप छवि (ईएन)",
  active_period: "सक्रिय अवधि",
  en_item: "आइटम (ईएन)",
  local_item: "वस्तु (स्थानीय)",
  meta_title: "मेटा शीर्षक",
  meta_keywords: "मेटा कीवर्ड",
  meta_url: "मेटा यूआरएल",
  meta_canonical: "मेटा कैनोनिकल",
  meta_author: "मेटा लेखक",
  meta_publisher: "मेटा प्रकाशक",
  meta_lang: "मेटा लैंग",
  meta_desc: "मेटा डेस्क",
  meta_image: "मेटा इमेज",
  page: "पृष्ठ",
  item: "आइटम",
  remove_desktop_image: "डेस्कटप छवि हटाउनुहोस्",
  remove_mobile_image: "मोबाइल छवि हटाउनुहोस्",
  page_name: "पृष्ठ नाम",
  login_date: "लगइन मिति",
  ftd_amount_min: "न्यूनतम एफटीडी राशि",
  ftd_amount_max: "अधिकतम एफटीडी राशि",
  fl_provider_code: "पहिलो लन्च प्रदायक",
  fl_game_id: "फर्स्ट लॉन्च गेम आईडी",
  fl_game_name: "फर्स्ट लॉन्च गेम नेम",
  top_deposit: "शीर्ष जमा",
  top_withdrawal: "शीर्ष निकासी",
  top_promotion: "शीर्ष पदोन्नति",
  outstanding_balance: "उत्कृष्ट सन्तुलन",
  last_update_time: "अन्तिम अद्यावधिक समय",
  trace: "ट्रेस",
  trace_outstanding: "ट्रेस आउटस्टैंडिंग",
  outstanding: "उत्कृष्ट",
  clear_outstanding: "बाँकी रकम हटाउनुहोस्",
  meta_image_url: "मेटा इमेज यूआरएल",
  member_bonus: "सदस्य बोनस",
  crm_list: "सीआरएम सूची",
  advance_search: "अग्रिम खोज",
  deposit_count_from: "डिपोजिट काउंट फ्रॉम",
  deposit_count_to: "डिपोजिट काउंट टू",
  deposit_amount_from: "डिपोजिट रकम बाट",
  deposit_amount_to: "डिपोजिट रकम",
  min_day_no_login: "न्यूनतम दिन नो लॉगिन",
  min_day_no_deposit: "न्यूनतम दिन नो डिपॉजिट",
  last_login: "लास्ट लॉगिन",
  last_deposit: "लास्ट डिपॉजिट",
  phone: "फोन",
  email: "ईमेल",
  ip_whitelist: "आईपी व्हाइटलिस्ट",
  ip: "आईपी",
  payment_option: "भुक्तानी विकल्प",
  payment_mode: "भुक्तानी मोड",
  payment_desc: "पेमेन्ट डेस्क",
  success: "सफलता",
  failed: "असफल",
  bank_member_ewallet: "बैंक सदस्य (ई-वॉलेट)",
  processing: "प्रोसेसिंग",
  recipient_bank_id: "प्राप्तकर्ता बैंक आईडी",
  recipient_bank_acc_no: "प्राप्तकर्ता बैंक खाता नम्बर",
  ticket_auto_withdrawal_log: "टिकट लॉग (स्वत: निकासी)",
  resubmit_ticket: "पुन: सबमिट टिकट",
  ticket_export: "टिकट (निर्यात)",
  export_deposit: "एक्सपोर्ट (डिपॉजिट)",
  export_deposit_all: "एक्सपोर्ट ऑल (डिपॉजिट)",
  export_withdrawal: "निर्यात (निकासी)",
  export_withdrawal_all: "एक्सपोर्ट ऑल (निकासी)",
  export_member_all: "निर्यात सबै (सदस्य)",
  processed_rejected: "प्रोसेस्ड (रिजेक्टेड)",
  channel: "च्यानल",
  influencer: "इन्फ्लुएन्सर",
  ticket_id: "टिकट आईडी",
  recommend: "सिफारिस गर्नुहोस्",
  sequence: "अनुक्रम",
  statement_info: "बयान जानकारी",
  slots: "स्लट",
  livecasino: "लाइवकैसिनो",
  sportsbook: "खेल सट्टेबाजी",
  cockfight: "कॉकफाइट",
  member_list: "सदस्य सूची",
  operator: "अपरेटर",
  game_balance: "गेम ब्यालेन्स",
  claim_limit: "दावा सीमा",
  max_withdraw_multiple: "अधिकतम एकाधिक वापस लें",
  payment_gateway: "पेमेन्ट गेटवे",
  min_limit: "न्यूनतम सीमा",
  max_limit: "अधिकतम सीमा",
  total: "कुल",
  rebate_summary: "छूट सारांश",
  rebate_summary_daily: "छूट सारांश दैनिक",
  rebate_member: "छूट सदस्य",
  self: "स्वयं",
  system_balance: "सिस्टम ब्यालेन्स",
  rejected_onload: "रिजेक्टेड (अनलोड)",
  no_bonus: "कुनै बोनस छैन",
  audit_ticket: "अडिट टिकट",
  review_ticket: "समीक्षा टिकट",
  edit_promotion_group_norm_seq: "समूहमा प्रोमोशन क्रम व्यवस्थापन गर्नुहोस्",
  signup_bonus: "साइनअप बोनस",
  settlement_type: "सेटलमेन्ट प्रकार",
  carry_over: "कैरी ओवर",
  comm_sports: "आयोग (खेल)",
  comm_slots: "आयोग (स्लट)",
  comm_livecasino: "आयोग (लाइवकैसिनो)",
  comm_cockfight: "आयोग (कॉकफाइट)",
  comm_others: "आयोग (अन्य)",
  update_comm: "कमिशन अपडेट गर्नुहोस्",
  update_carry_over: "क्यारी ओभर अपडेट गर्नुहोस्",
  ewallet: "ई-वॉलेट",
  withdrawal_list: "निकासी सूची",
  audit_withdrawal: "अडिट निकासी",
  daily_withdrawal: "दैनिक निकासी",
  adjustment_log_affiliate: "समायोजन लग",
  daily_statement_affiliate: "दैनिक बयान (एजेंट)",
  earning: "कमाई",
  pnl: "पी एंड एल",
  review_affiliate_ticket: "एफिलिएट टिकट समीक्षा गर्नुहोस्",
  audit_affiliate_ticket: "एफिलिएट टिकट अडिट गर्नुहोस्",
  turnover_downline: "टर्नओवर (डाउनलाइन)",
  valid_turnover_downline: "वैध टर्नओवर (डाउनलाइन)",
  winlose_downline: "विनलोस (डाउनलाइन)",
  bet_count_downline: "बेट काउंट (डाउनलाइन)",
  turnover_member: "टर्नओवर (सदस्य)",
  valid_turnover_member: "वैध टर्नओवर (सदस्य)",
  winlose_member: "विनलोज (सदस्य)",
  bet_count_member: "बेट काउंट (सदस्य)",
  dashboard_affiliate: "डैशबोर्ड (एजेंट)",
  total_agent: "कुल एजेंट",
  top_turnover: "शीर्ष टर्नओवर",
  bonus_count: "बोनस गणना",
  deposit_amount_downline: "जमा राशि (डाउनलाइन)",
  deposit_count_downline: "डिपॉजिट काउंट (डाउनलाइन)",
  bonus_amount_downline: "बोनस राशि (डाउनलाइन)",
  bonus_count_downline: "बोनस काउंट (डाउनलाइन)",
  deposit_amount_member: "डिपोजिट रकम (सदस्य)",
  deposit_count_member: "डिपोजिट काउन्ट (सदस्य)",
  bonus_amount_member: "बोनस रकम (सदस्य)",
  bonus_count_member: "बोनस गणना (सदस्य)",
  verified: "प्रमाणित",
  round_id: "राउन्ड आईडी",
  unfinish_round: "अनफिनिश राउंड",
  smartico_bonus_report: "स्मार्टिको बोनस रिपोर्ट",
  unclaimed_amount: "बेवारिसे रकम",
  claimed_amount: "दावी गरिएको रकम",
  unclaimed_count: "लावारिस गिनती",
  claimed_count: "क्लेड काउंट",
  submit_time: "सिर्जना गरिएको मिति",
  deposit_time: "परिमार्जित मिति",
  funds_list: "टिकट सूची",
  fund_transfer_provider: "कोष स्थानान्तरण प्रदायक",
  daifu_list_auto_withdrawal: "टिकट सूची (स्वत: निकासी)",
  btn_href: "बटन ह्रेफ",
  btn_text: "बटन पाठ",
  recent_inbox_claim: "हालको इनबक्स दावी",
  raise_deposit_ticket_gateway: "जम्मा टिकट उठाउनुहोस् (गेटवे)",
  gateway_acc: "गेटवे खाता",
  provider_winlose_member: "प्रदाता विनलोज (सदस्य)",
  review_by: "समीक्षा द्वारा",
  daifu_list_auto_withdrawal_export: "टिकट निर्यात (स्वत: निकासी)",
  retention: "रेटेंटन",
  current_month_active_user: "हालको महिना सक्रिय प्रयोगकर्ता",
  current_month_active: "वर्तमान महिना सक्रिय",
  first_month: "पहिलो महिना",
  fmwinlose: "एफएमविनलोज़",
  fmdeposit_amount: "एफएमडिपोजिट रकम",
  cohort: "कोहोर्ट",
  promotion_withdrawal_summary: "पदोन्नति निकासी सारांश",
  promotion_withdrawal_summary_detail: "पदोन्नति निकासी सारांश (विवरण)",
  unique_player: "अद्वितीय खिलाड़ी",
  year: "वर्ष | वर्षहरू",
  audit_time_modified: "परिमार्जित मिति",
  audit_time_created: "सिर्जना गरिएको मिति",
  approve_time: "परिमार्जित मिति",
  unique_login_count: "विशिष्ट लगइन संख्या",
  unique_deposit_count: "विशिष्ट जम्मा संख्या",
  unique_withdrawal_count: "विशिष्ट निकासी संख्या",
  second_deposit_count: "दोश्रो जम्मा संख्या",
  unique_login: "अद्वितीय लगइन",
  unique_withdrawal: "अद्वितीय निकासी",
  second_deposit: "सेकेन्ड डिपोजिट",
  deposit_withdrawal_different: "जम्मा र निकासी फरक",
  ngr: "एनजीआर",
  audit_list: "अडिट सूची",
  rollback_count: "रोलबैक काउंट",
  rejected_ticket_id: "अस्वीकृत टिकट आईडी",
  rollback: "रोलबैक",
  recipient_bank_acc_holder: "प्राप्तकर्ता बैंक खाता धारक",
  reject_date: "अस्वीकृत मिति",
  processing_date: "प्रक्रिया मिति",
  manual_approve: "अनुमोदन (मैनुअल)",
  pending_review_funds: "लंबित और समीक्षा टिकट",
  table_id: "तालिका आईडी",
  member_label: "सदस्य लेबल",
  label_name: "लेबल नाम",
  label: "लेबल",
  available_label: "उपलब्ध लेबल",
  iframe: "इफ्राम",
  iframe_url: "इफ्रेम यूआरएल",
  exchange_rate: "विनिमय दर",
  rate: "दर",
  rate_php: "रेट पीएचपी",
  ticket_withdrawal_rollback: "टिकट निकासी रोलबैक",
  smartico_bonus_report_expired: "स्मार्टिको बोनस रिपोर्ट (एक्सपायर)",
  reward_type: "इनाम प्रकार",
  turnover_rebate: "टर्नओवर छूट",
  turnover_rebate_1: "वीआईपी टियर",
  turnover_rebate_2: "टर्नओवर टियर",
  vip_cycle_day: "वीआईपी साइकिल डे",
  is_addon: "एडन है",
  no_reward: "कुनै इनाम छैन",
  cash: "नगद",
  cs: "ग्राहक सेवा",
  social_platform: "सामाजिक मंच",
  edit_vip: "भीआईपी सम्पादन गर्नुहोस्",
  edit_vip_provider: "वीआईपी प्रदायक सम्पादन गर्नुहोस्",
  turnover_tier: "टर्नओवर टियर",
  rebate_rate: "छूट दर",
  edit_turnover_tier: "टर्नओभर स्तर सम्पादन गर्नुहोस्",
  delete_turnover_tier: "टर्नओवर टियर मेट्नुहोस्",
  vip_log: "वीआईपी लॉग",
  member_full_record: "सदस्य पूर्ण रेकर्ड",
  before: "पहिले",
  after: "पछि",
  maintain: "बनाए रखो",
  actual_rebate: "वास्तविक छूट",
  rounded_rebate: "गोलाकार छूट",
  rebate_mode: "छूट मोड",
  inbox_id: "इनबक्स आईडी",
  rebate_type: "छूट प्रकार",
  promotion_type: "पदोन्नति प्रकार",
  bonus_rate_1: "दर 1(%)",
  bonus_rate_2: "दर 2 (%)",
  bonus_rate_3: "दर 3 (%)",
  bonus_rate_4: "दर 4 (%)",
  bonus_rate_5: "दर 5 (%)",
  bonus_rate_6: "दर 6 (%)",
  bonus_rate_7: "दर 7 (%)",
  bonus_rate_8: "दर 8 (%)",
  bonus_rate_9: "दर 9 (%)",
  bonus_rate_10: "दर 10 (%)",
  delete_all: "सबै मेट्नुहोस्",
  rescue_fund: "रेस्क्यु फण्ड",
  up: "माथि",
  down: "डाउन",
  rate_percent: "दर %",
  cycle: "चक्र",
  actual_amount: "वास्तविक राशि",
  rounded_amount: "गोलाकार राशि",
  rescue_id: "रेस्क्यू आईडी",
  rescue_name: "उद्धार नाम",
  min_lose: "मिन लॉस",
  max_payout: "मैक्स पेआउट",
  payout_method: "पेआउट विधि",
  target_group: "लक्ष्य समूह",
  member_vip_id: "सदस्य वीआईपी आईडी",
  daily: "दैनिक",
  weekly: "साप्ताहिक",
  monthly: "मासिक",
  edit_batch: "ब्याच सम्पादन गर्नुहोस्",
  current_level: "हालको स्तर",
  next_level: "पछिल्लो स्तर",
  bet_value: "शर्त मूल्य",
  line_bet: "लाइन बेट",
  total_round: "टोटल राउंड",
  audit_by: "अडिट द्वारा",
  possible_next_level: "सम्भव अर्को स्तर",
  maintain_deposit: "रिटेन डिपोजिट",
  maintain_turnover: "टर्नओवर बनाए रखें",
  starting_deposit: "स्टार्टिंग डिपोजिट",
  starting_turnover: "टर्नओवर शुरू करना",
  cycle_deposit: "साइकल डिपोजिट",
  cycle_turnover: "चक्र टर्नओवर",
  vip_list: "वीआईपी सूची",
  up_maintain: "अप मेन्टेन",
  down_lowest: "डाउन लोअर",
  manual: "मैनुअल",
  daily_winlose_game: "डेली विनलोज (गेम)",
  actionaff: "एक्शन (एजेंट)",
  onload: "अनलोड",
  update_status: "अद्यावधिक स्थिति",
  role_settings: "भूमिका सेटिङ",
  customer_services: "ग्राहक सेवा",
  marketing: "मार्केटिंग",
  finance: "वित्त",
  payment: "भुक्तानी",
  risk_management: "जोखिम व्यवस्थापन",
  pt: "पीटी",
  wallet_history: "वालेट हिस्ट्री",
  ticket_amount: "टिकट रकम",
  ignore_risk: "जोखिम को अनदेखा करें",
  permitted_amount: "अनुमति प्राप्त रकम",
  all_pending_ticket: "सभी लंबित टिकट",
  rescue_fund_summary: "रेस्क्यू फंड सारांश",
  rescue_fund_summary_daily: "रेस्क्यू फंड सारांश दैनिक",
  rescue_fund_member: "उद्धार कोषका सदस्य",
  master: "मास्टर",
  account_type: "खाता प्रकार",
  freeze: "फ्रीज",
  domain_member_setup: "सदस्य साइट डोमेन सेटअप",
  domain: "डोमेन",
  domain_list: "डोमेन सूची",
  domain_application: "डोमेन अनुप्रयोग",
  domain_status: "डोमेन स्थिति",
  domain_group: "डोमेन समूह",
  operator_id: "अपरेटर आईडी",
  domain_type: "डोमेन प्रकार",
  module: "मोड्युल",
  template: "टेम्प्लेटहरू",
  custom: "कस्टम",
  default: "पूर्वनिर्धारित",
  payment_provider: "भुक्तानी प्रदायक",
  payment: "भुक्तानी",
  deactivate: "निष्क्रिय",
  name_server: "नाम सर्भर",
  server_account: "सर्भर खाता",
  service_provider: "सेवा प्रदायक",
  process: "प्रक्रिया",
  provider_operator: "प्रदायक अपरेटर",
  bet_limit_member: "@: ui.bet_limit (@: यूआई.सदस्य)",
  global: "ग्लोबल सेटिंग्स",
  second_id: "दोस्रो आईडी",
  unverified: "अप्रमाणित",
  pt_affiliate: "एजेंट प्लेटफ़ॉर्म शुल्क (%)",
  recipient_bank: "प्राप्तकर्ता बैंक",
  deposit_type: "डिपोजिट प्रकार",
  security_fund: "सुरक्षा कोष",
  adjust_balance_op: "अपरेटर वालेट समायोजन गर्नुहोस्",
  adjust_security_deposit_op: "एडजस्ट अपरेटर सेक्युरिटी फण्ड",
  marquee: "मार्की",
  marquee_content: "मार्की सामग्री",
  edit_marquee: "मार्की संपादित करें",
  domain_available: "डोमेन उपलब्ध",
  daily_withdrawal_frequency: "दैनिक निकासी आवृत्ति",
  maintenance: "रखरखाव",
  max_withdrawal: "अधिकतम निकासी",
  min_balance: "न्यूनतम सन्तुलन",
  affiliate_report: "एजेंट रिपोर्ट",
  cash_balance: "क्यास ब्यालेन्स",
  copy_success: "सफलतापूर्वक प्रतिलिपि बनाउनुहोस्!",
  copy_failed: "प्रतिलिपि असफल भयो!",
  your_website: "तपाईंको वेबसाइट",
  correction_promo: "पदोन्नति जोड्नुहोस्",
  others: "अन्य",
  audit_log: "अडिट लग",
  view: "दृश्य",
  price: "मूल्य",
  package_level: "प्याकेज स्तर",
  bo_right: "बीओ राइट",
  english: "अङ्ग्रेजी",
  simplified_chinese: "चीनी (सीएन)",
  traditional_chinese: "चीनी (टीडब्ल्यू)",
  philippine: "फिलीपींस",
  thai: "थाई",
  vietnamese: "वियतनामी",
  indonesian: "इन्डोनेसियाली",
  myanmar: "म्यान्मार",
  japanese: "जापानी",
  korean: "कोरियन",
  package_type: "प्याकेज प्रकार",
  full_back_office_access_right: "फुल ब्याक अफिस एक्सेस राइट",
  read_only_back_office: "रीडओनली बैक ऑफिस",
  language: "भाषा",
  lang_code: "भाषा कोड",
  description: "विवरण",
  provider_type: "प्रदायक प्रकार",
  logo: "लोगो",
  theme_provider: "विषयवस्तु प्रदायक",
  theme_content: "विषयवस्तु सामग्री",
  content_id: "सामग्री आईडी",
  content_desc: "सामग्री डेस्क",
  theme_content_position: "विषयवस्तु सामग्री स्थिति",
  theme: "विषयवस्तु",
  theme_code: "विषयवस्तु कोड",
  theme_name: "विषयवस्तु नाम",
  color: "रङ",
  position: "स्थिति",
  site_name: "साइट नाम",
  theme_color: "विषयवस्तु रङ",
  theme_purchased: "थीम खरीदे गए",
  total_purchased: "कुल खरीदा गया",
  purchased_date: "किनिएको मिति",
  purchase: "खरीद",
  total_site: "कुल साइट",
  content_setup: "सामग्री सेटअप",
  site_list: "साइट सूची",
  site_id: "साइट आईडी",
  draft_version: "मस्यौदा संस्करण",
  prod_version: "उत्पादन संस्करण",
  production_version: "उत्पादन संस्करण",
  info: "जानकारी",
  setting: "सेटिङ",
  site_info: "साइट जानकारी",
  menu: "मेनु",
  game_menu: "गेम मेनु",
  special_menu: "विशेष मेनु",
  setting_menu: "सेटिङ मेनु",
  error: "त्रुटि",
  sync_all: "सबै समक्रमण गर्नुहोस्",
  theme_content_group: "विषयवस्तु सामग्री समूह",
  content_group: "सामग्री समूह",
  content_group_desc: "सामग्री समूह डेस्क",
  parent_content_id: "अभिभावक सामग्री आईडी",
  bo_default_domain: "बीओ पूर्वनिर्धारित डोमेन",
  domain_id: "डोमेन आईडी",
  deactive: "निष्क्रिय",
  site_sync: "साइट सिंक",
  upload: "अपलोड",
  comingSoon: "जल्द ही आ रहा है",
  profile_setting: "प्रोफाइल सेटिङ",
  bank: "बैंक",
  company: "कम्पनी",
  own: "आफ्नै",
  operator_setting: "अपरेटर सेटिङ",
  external_id: "बाह्य आईडी",
  ticket: "टिकट",
  bank_owner: "बैंक मालिक",
  exchanged_currency: "विनिमय मुद्रा",
  company_bank_owner: "कम्पनी बैंक मालिक",
  ticket_list_member: "टिकट सूची (सदस्य)",
  game_name_exclude: "खेल नाम बहिष्करण",
  tab: "टैब",
  about_us: "हाम्रो बारेमा",
  privacy_policy: "गोपनीयता नीति",
  responsible_gaming: "जिम्मेदार गेमिंग",
  banking: "बैंकिंग",
  faqs: "एफएक्यूएस",
  advertisement: "विज्ञापन",
  px_pixel_id: "पीएक्स पिक्सेल आईडी",
  px_token: "पीएक्स टोकन",
  af_dev_key: "अफ देव कुञ्जी",
  af_apps_id: "एएफ एप्स आईडी",
  pp_tid: "पीपी टीआईडी",
  pp_pid: "पीपी पीआईडी",
  pp_aid: "पीपी एड",
  gtm_id: "जीटीएम आईडी",
  service_provider_url: "सेवा प्रदायक यूआरएल",
  script_inject: "स्क्रिप्ट इन्जेक्ट",
  head_script: "हेड स्क्रिप्ट",
  body_script: "बॉडी स्क्रिप्ट",
  ads_id: "विज्ञापन आईडी",
  member_detail: "सदस्य विवरण",
  memberreport: "सदस्य प्रतिवेदन",
  member_log: "सदस्य लग",
  general: "जनरल",
  top_theme: "शीर्ष थीम",
  hot_game: "हॉट गेम",
  hot_list: "हट लिस्ट",
  new_game: "नयाँ खेल",
  popular_game: "लोकप्रिय खेल",
  featured_game: "फीचर्ड गेम",
  new_list: "नयाँ सूची",
  popular_list: "लोकप्रिय सूची",
  featured_list: "फीचर्ड लिस्ट",
  provider_new_game: "प्रदायक नयाँ खेल",
  provider_popular_game: "प्रदायक लोकप्रिय खेल",
  provider_featured_game: "प्रदाता फीचर्ड गेम",
  website: "वेबसाइट",
  site_customization: "साइट अनुकूलन",
  export_all: "सबै निर्यात गर्नुहोस्",
  export_one: "निर्यात (हालको पृष्ठ)",
  daily_ledger: "दैनिक लेजर",
  daily_ledger_member: "दैनिक लेजर (सदस्य)",
  promotion_signup_unused: "अप्रयुक्त साइनअप पदोन्नति",
  promotion_signup_ongoing: "जारी साइनअप पदोन्नति",
  promotion_signup_winlose: "साइनअप प्रमोशन विनलोज",
  promotion_signup_winlose_operator: "साइनअप प्रमोशन विनलोस (ऑपरेटर)",
  promotion_signup_winlose_member: "साइनअप प्रमोशन विनलोस (सदस्य)",
  total_player_balance: "टोटल प्लेयर ब्यालेन्स",
  search_all: "सबै खोजी गर्नुहोस्",
  mbsetting: "सेटिङ",
  todays_highlights: "टुडेज हाइलाइट्स",
  deposit_player: "डिपोजिट प्लेयर",
  withdrawal_player: "निकासी खिलाड़ी",
  kill_rate: "किल रेट",
  login_player: "लगइन प्लेयर",
  operation_management: "सञ्चालन",
  game_management: "खेल",
  member_management: "सदस्य",
  affiliate_management: "एजेन्ट",
  promotion_management: "पदोन्नति",
  mbcampaign: "अभियान",
  promo_allday: "ऑल डे",
  promo_daily: "दैनिक",
  promo_daily_first_deposit: "डेली फर्स्ट डिपॉजिट",
  promo_deposit_monthly: "डिपोजिट काउन्ट मासिक",
  promo_deposit_signup: "डिपोजिट काउन्ट साइनअप",
  promo_deposit_weekly: "डिपॉजिट काउंट वीकली",
  promo_newbie: "नौसिखिया",
  promo_once: "एक बार",
  dd_review: "समीक्षा",
  game_provider_management: "प्रदायक",
  exchanged_amount: "विनिमय राशि",
  operator_summary: "अपरेटर सारांश",
  business_id: "बिजनेस आईडी",
  game_name_exclude_log: "खेल नाम बहिष्करण लग",
  cn: "सीएन",
  local: "स्थानीय",
  taken: "लिया",
  receiver_bank: "रिसीभर बैंक",
  receiver_bank_acc_no: "रिसीवर बैंक एसीसी नं।",
  receiver_bank_acc_holder: "रिसीवर बैंक एसीसी होल्डर",
  add_balance: "ब्यालेन्स थप्नुहोस्",
  deduct_balance: "ब्यालेन्स घटाउनुहोस्",
  sync_site_content: "समक्रमण साइट सामग्री",
  payment_setting: "भुक्तानी सेटिङ",
  payment_own: "आफ्नै",
  payment_global: "ग्लोबल",
  livechat: "लाइवचैट",
  chat_id: "लाइभच्याट लाइसेन्स कुञ्जी",
  chat_provider: "लाइभच्याट प्रदायक",
  auto_cycle: "चक्र",
  auto_all: "सबै",
  completed_amount: "पूरा भएको रकम",
  website_launched: "वेबसाइट लॉन्च",
  total_operators: "कुल अपरेटरहरू",
  today_active: "आज सक्रिय",
  new_player_verified_signup: "नयाँ खेलाडी प्रमाणित / साइनअप",
  total_players: "कुल खिलाड़ी",
  depo_withdrawal_diff: "डेपो-विथ डिफरेंस",
  claim_count: "दावा गणना",
  ggr: "जीजीआर",
  member_balance: "सदस्य सन्तुलन",
  players: "खेलाडीहरू",
  provider_pt: "प्रदाता पीटी",
  base: "आधार",
  topup_id: "टपअप आईडी",
  credential: "क्रेडेन्शियल",
  credential_1: "क्रेडेन्शियल १",
  credential_2: "क्रेडेंशियल 2",
  credential_3: "क्रेडेंशियल 3",
  credential_4: "क्रेडेन्शियल 4",
  credential_5: "क्रेडेन्शियल 5",
  credential_6: "क्रेडेन्शियल 6",
  credential_7: "क्रेडेन्शियल 7",
  credential_8: "क्रेडेन्शियल 8",
  credential_9: "क्रेडेन्शियल 9",
  credential_10: "क्रेडेंशियल 10",
  limit: "सीमा",
  create: "सिर्जना गर्नुहोस्",
  hint: "संकेत",
  quickSetup: "क्विक सेटअप",
  next: "अगला",
  setUpTheme: "सेटअप विषयवस्तु",
  checkOut: "चेक आउट",
  standardPackage: "मानक पैकेज",
  siteName: "साइट नाम",
  information: "सूचना",
  useThisTemplate: "यो टेम्प्लेट प्रयोग गर्नुहोस्",
  summary: "सारांश",
  createOperatorAccount: "अपरेटर खाता सिर्जना गर्नुहोस्",
  operatorId: "अपरेटर आईडी",
  operatorPwd: "ऑपरेटर पासवर्ड",
  new_website: "नयाँ वेबसाइट",
  operator_information: "अपरेटर सूचना",
  bo_link: "बीओ लिंक",
  daily_summary_sms: "दैनिक सारांश एसएमएस",
  daily_summary_sms_operator: "दैनिक सारांश एसएमएस ऑपरेटर",
  daily_summary_sms_operator_detail: "दैनिक सारांश एसएमएस अपरेटर विवरण",
  sms_count: "एसएमएस गणना",
  provider_winlose_operator_pt: "प्रदाता विनलोज (ऑपरेटर पीटी)",
  pt_on: "पीटी ऑन",
  share_operator: "शेयर अपरेटर",
  share_company: "शेयर कम्पनी",
  token_log: "टोकन लॉग",
  template_code: "टेम्प्लेट कोड",
  template_name: "टेम्प्लेट नाम",
  mini_game: "मिनी गेम",
  max_game_reward: "मैक्स गेम रिवार्ड",
  max_chance_per_day: "मैक्स चांस प्रति दिन",
  is_recurring_chance: "पुनरावृत्ति",
  token_request: "टोकन",
  enabled: "सक्षम पारिएको",
  disabled: "अक्षम पारिएको",
  unlimited: "असीमित",
  max_chance_unlimited: "अधिकतम मौका प्रति दिन असीमित",
  mini_game_template: "मिनी गेम टेम्प्लेट",
  reward_code: "इनाम कोड",
  reward_name: "इनाम नाम",
  reward_description: "इनाम विवरण",
  reward_probability: "इनाम संभाव्यता",
  total_game: "टोटल गेम",
  total_played_mini_game: "टोटल प्ले मिनी गेम",
  total_played_mini_game_detail: "टोटल प्ले मिनी गेम डिटेल",
  total_played_mini_game_detail_operator: "टोटल प्ले मिनी गेम डिटेल (ऑपरेटर)",
  daily_pnl_operator: "डेली पी एंड एल (ऑपरेटर)",
  token: "टोकन",
  token_1: "टोकन 1",
  token_2: "टोकन 2",
  token_3: "टोकन 3",
  token_4: "टोकन 4",
  token_5: "टोकन 5",
  token_6: "टोकन 6",
  token_7: "टोकन 7",
  cash_1: "कैश 1",
  cash_2: "कैश 2",
  cash_3: "कैश 3",
  cash_4: "कैश 4",
  cash_5: "कैश 5",
  cash_6: "कैश 6",
  cash_7: "नगद 7",
  daily_login: "डेली चेक-इन (डेली लॉगिन)",
  daily_login_update: "डेली चेक-इन (डेली लॉगिन) अपडेट",
  game_result_reward: "खेल परिणाम (इनाम)",
  current_streak: "वर्तमान स्ट्रीक",
  login_streak: "लगइन स्ट्रीक",
  total_token: "टोटल टोकन",
  total_mini_game_token_used: "टोटल मिनी गेम टोकन प्रयुक्त",
  total_mini_game_token_used_detail: "टोटल मिनी गेम टोकन प्रयुक्त विवरण",
  total_mini_game_token_used_detail_operator: "टोटल मिनी गेम टोकन प्रयुक्त विवरण (ऑपरेटर)",
  total_reward: "कुल इनाम",
  total_mini_game_reward: "टोटल मिनी गेम रिवार्ड",
  total_mini_game_reward_detail: "कुल मिनी गेम इनाम विवरण",
  total_mini_game_reward_detail_operator: "टोटल मिनी गेम रिवार्ड डिटेल (ऑपरेटर)",
  token_balance: "टोकन ब्यालेन्स",
  free_game_token: "फ्री गेम टोकन",
  bo_url: "बैकऑफिस यूआरएल",
  copied: "प्रतिलिपि गरिएको",
  callback: "कॉलबैक",
  api: "एपीआई",
  prefix: "उपसर्ग",
  delimiter: "डिलिमिटर",
  url_callback_deposit: "डिपोजिट कलब्याक यूआरएल",
  url_callback_withdrawal: "निकासी कलबैक यूआरएल",
  url_callback_affiliate: "एजेंट कॉलबैक यूआरएल",
  url_api_deposit: "डिपोजिट कलबैक यूआरएल (एपीआई)",
  url_api_withdrawal: "निकासी कॉलबैक यूआरएल (एपीआई)",
  url_api_balance: "बैलेंस कॉलबैक यूआरएल (एपीआई)",
  prefix_deposit: "डिपोजिट उपसर्ग",
  prefix_withdrawal: "निकासी उपसर्ग",
  prefix_affiliate: "एजेंट उपसर्ग",
  prefix_delimiter: "डिलिमिटर उपसर्ग",
  merchant: "व्यापारी",
  app_id: "अनुप्रयोग आईडी",
  secret_key: "गुप्त कुञ्जी",
  deposit_secret_key: "डिपोजिट गुप्त कुञ्जी",
  withdrawal_secret_key: "निकासी गुप्त कुंजी",
  partners: "साझेदारहरू",
  partner_name: "साथीको नाम",
  win: "जीत",
  manifest: "प्रकट",
  crop: "फसल",
  cropImage: "फसल छवि",
  api_url: "एपीआई यूआरएल",
  start_date_time: "सुरु मिति समय",
  end_date_time: "अन्त्य मिति समय",
  authentication_key: "प्रमाणीकरण कुञ्जी",
  one_week: "1 सप्ताह",
  two_week: "2 सप्ताह",
  one_month: "१ महिना",
  two_month: "2 महीने",
  six_month: "6 महीने",
  edit_promotion_end_date: "पदोन्नति समाप्ति मिति सम्पादन गर्नुहोस्",
  android_app_link: "एन्ड्रोइड अनुप्रयोग लिङ्क",
  add_android_app_link: "एन्ड्रोइड अनुप्रयोग लिङ्क थप्नुहोस्",
  operator_details: "अपरेटर विवरण",
  bsb: "बीएसबी",
  payid: "पे आईडी",
  cuit: "सीयूआईटी",
  merchant_key: "मर्चेन्ट कुञ्जी",
  aes_key: "एईएस कुञ्जी",
  paycode: "पेकोड",
  api_key: "एपीआई कुञ्जी",
  referral: "सिफारिस पुरस्कार",
  minimum_deposit: "न्यूनतम जमा",
  minimum_withdrawal: "न्यूनतम निकासी",
  maximum_withdrawal: "अधिकतम निकासी",
  cpi: "CPI",
  cpi_enrol: "CPI दर्ता",
  interested: "रुचि भएको",
  non_pickup: "नउठाइएको",
  invalid: "अवैध",
  cpi_member_list: "CPI सदस्य सूची",
  leaderboard: "लीडरबोर्ड",
  capacity: "क्षमता",
  reward_count: "पुरस्कार संख्या",
  is_settled: "सम्पन्न भएको हो",
  settlement_date: "सम्पन्न मिति",
  prize: "पुरस्कार",
  count: "गणना",
  multiplier: "गुणक",
  ranking: "क्रम",
  leaderboard_ranking: "लीडरबोर्ड क्रम",
  joined_date: "सामेल भएको मिति",
  ready: "तयार",
  busy: "व्यस्त",
  phone_list: "फोन सूची",
  single: "एकल",
  batch: "समूह",
  cpi_operator_phone_list: "CPI अपरेटर फोन सूची",
  selected: "चयन गरिएको",
  call: "कल",
  private_key: "निजी कुञ्जी",
  public_key: "सार्वजनिक कुञ्जी",
  multi_call: "बहुविध कलहरू",
  add_custom: "अनुकूल थप्नुहोस्",
  custom_list: "अनुकूल सूची",
  assignee: "नियुक्त व्यक्ति",
  urgency: "तात्कालिकता",
  urgency_1: "कम",
  urgency_2: "मध्यम",
  urgency_3: "उच्च",
  edit_custom: "अनुकूल सम्पादन गर्नुहोस्",
  cpi_custom_list: "CPI अनुकूल सूची",
  free_coin_signup: "निःशुल्क पोइन्ट (साइनअप)",
  free_coin_daily: "निःशुल्क पोइन्ट (दैनिक)",
  free_coin_min_withdrawal: "न्यूनतम निकासी (निःशुल्क पोइन्ट)",
  free_coin_per_unit: "निःशुल्क पोइन्ट विनिमय दर (पोइन्ट = {currency} 1)",
  adjust_free_balance: "निःशुल्क ब्यालेन्स समायोजन",
  adjust_free_balance_log: "नि:शुल्क शेष लग",
  signup: "साइन अप",
  adjust: "समायोजन गर्नुहोस्",
  ai_assistant: "एआई सहायक",
  en_name: "नाम (EN)",
  cn_name: "नाम (CN)",
  local_name: "नाम (स्थानीय)",
  img_small: "तस्बिर (सानो)",
  img_large: "तस्बिर (ठूलो)",
  small_image: "सानो तस्बिर",
  large_image: "ठूलो तस्बिर",
  forgot_password: "पासवर्ड बिर्सनुभयो",
  update_password: "पासवर्ड अद्यावधिक गर्नुहोस्",
  contact: "सम्पर्क",
  keyss: "कुञ्जी",
  iv: "IV",
  callback_public_key: "कलब्याक सार्वजनिक कुञ्जी",
  free_game: "नि:शुल्क खेल",
  version_no: "संस्करण नम्बर",
  client_id: "ग्राहक आईडी",
  symmetric_key: "सममित कुञ्जी",
  deposit_token: "जम्मा टोकन",
  withdrawal_token: "निकासी टोकन",
  tac_bank: "ओटीपी (बैंक)",
  tac_login: "ओटीपी (लगइन)",
  tac_signup: "ओटीपी (साइन अप)",
  tac_signup_aff: "ओटीपी (सहयोगी साइन अप)",
  merchant_name: "व्यापारीको नाम",
  tele_status: "टेल स्थिति",
  follow_up: "पछ्याउने",
  call_type: "कलको प्रकार",
  on_call_list: "कल सूचीमा",
  inbox_valid_day: "इनबक्स वैध दिन",
  manual_deposit: "म्यानुअल जमाना",
  withdrawal_result: "निकासी परिणाम",
  widget_id: "विजेट आईडी",
  property_id: "सम्पत्ति आईडी",
  referee: "सिफारिस गरिएको व्यक्तिको पुरस्कार",
  game_result_free_slots: "खेल परिणाम (निःशुल्क स्लट)",
  crypto_address: "क्रिप्टो ठेगाना",
  crypto_network: "क्रिप्टो नेटवर्क",
  crypto: "क्रिप्टो",
  exchange_currency: "विनिमय मुद्रा",
  base_rate: "मूल दर",
  white_label: "White Label",
  aggregator: "एग्रिगेटर",
  deposit_rate: "जमा दर",
  withdrawal_rate: "निकासी दर",
  pending_bet_list_wbet: "विचाराधीन बाजी सूची (WBET)",
  bet_amount: "बाजी रकम",
  actual_bet_amount: "वास्तविक बाजी रकम",
  pending_bet_list_others: "विचाराधीन बाजी सूची (अन्य स्पोर्ट्सबुक)",
  dob: "जन्म मिति",
  mail_address: "पत्राचार ठेगाना",
  crypto_withdrawal: "क्रिप्टो निकासी",
  institute_bank_code: "संस्थाको बैंक कोड",
  pending_bet_list_9w: "विचाराधीन बाजी सूची (9W)",
  linkage: "लिङ्केज",
  linkage_op: "लिङ्केज अपरेटर",
  member_linkage: "सदस्य लिङ्केज",
  risk_weight: "जोखिम तौल",
  full_linkage: "पूर्ण लिङ्केज",
  total_risk_score: "कुल जोखिम स्कोर",
  linkage_value: "लिङ्केज मान",
  source_occurrence_count: "स्रोत उपस्थितिको संख्या",
  source_last_seen_at: "अन्तिम पटक देखिएको (स्रोत)",
  target_occurrence_count: "लक्ष्य उपस्थितिको संख्या",
  target_last_seen_at: "अन्तिम पटक देखिएको (लक्ष्य)",
  member_linkage_detail: "सदस्य लिङ्केज विवरण",
  merchant_uid: "व्यापारी आईडी",
  merchant_no: "व्यापारी नम्बर",
  slot_view: "स्लट दृश्य",
  settlement_list_affiliate: "निपटान सूची (अफिलिएट)",
  source: "स्रोत",
  earning_breakdown: "आय विवरण",
  deposit_bonus: "जम्मा बोनस",
  winlose_turnover: "जित/हार/टर्नओभर",
  cost: "लागत",
  promotion_voucher: "प्रमोशन भाउचर",
  voucher_id: "भुक्ति आईडी",
  voucher_cash: "भुक्ति कैश",
  ticketvoucher: "टिकट भाउचर",
  ticket_voucher_list_member: "टिकट भाउचर सूची (सदस्य)",
  ticket_voucher_list: "टिकट भाउचर सूची",
  pending_review_funds_voucher: "प्रतीक्षारत र समीक्षा भइरहेको टिकट भाउचर",
  all_pending_ticket_voucher: "सबै प्रतीक्षारत टिकट भाउचर",
  ticket_voucher_detail: "टिकट भाउचर विवरण",
  raise_deposit_ticket_voucher: "जम्मा टिकट भाउचर सिर्जना",
  raise_deposit_ticket_voucher_gateway: "जम्मा टिकट भाउचर गेटवे सिर्जना",
  sos: "SOS टपअप",
  sos_accumulate_deposit: "SOS टपअप (सञ्चित जम्मा)",
  greeting: "अभिवादन",
  message: "सन्देश",
  get_voucher: "भाउचर प्राप्त गर्नुहोस्",
  get_message: "सन्देश प्राप्त गर्नुहोस्",
  voucher: "भाउचर",
  code: "कोड",
  redeemed_by: "द्वारा रिडिम गरिएको",
  redeemed_by_operator: "द्वारा रिडिम गरिएको (अपरेटर)",
  redeemed_at: "रिडिम गरिएको समय",
  created_at: "सिर्जना गरिएको समय",
  redeemed: "रिडिम गरिएको",
  member_sos_click_log: "सदस्य SOS क्लिक लग",
  member_wallet_voucher_log: "सदस्य वालेट भाउचर लग",
  member_voucher_redeemed_log: "सदस्य भाउचर रिडेम्पसन लग",
  action_by_operator: "कार्य (अपरेटरद्वारा)",
  redeem_cash: "नगद रिडिम",
  generate_voucher: "भाउचर सिर्जना",
  url_api_freecredit: "निःशुल्क क्रेडिट कलब्याक URL",
  prefix_freecredit: "निःशुल्क क्रेडिट उपसर्ग",
  free_credit_member: "निःशुल्क क्रेडिट सदस्य",
  free_credit_provider: "निःशुल्क क्रेडिट प्रदायक",
  ticket_detail_fcp: "टिकट विवरण (निःशुल्क क्रेडिट प्रदायक)",
  ticket_list_processed: "टिकट सूची (प्रक्रिया गरिएको)",
  mission: "मिशन",
  non_slot_view: "नन स्लट दृश्य",
  banner: "ब्यानर",
  trigger: "ट्रिगर",
  event_type: "इभेन्ट प्रकार",
  action_type: "कार्य प्रकार",
  msg_greeting: "अभिवादन (सन्देश)",
  msg_title: "शीर्षक (सन्देश)",
  msg_body: "सन्देश सामग्री",
  send_message: "सन्देश पठाउनुहोस्",
  promo_type: "प्रमो प्रकार",
  repeatable: "दोहोर्नुहोस्",
  rules: "नियम",
  clear_outstanding_log: "बक्यौता लग खाली गर्नुहोस्",
  free_credit_withdrawal_amount: "फ्री क्रेडिट निकासी रकम",
  fc_withdrawal_amount: "FC निकासी रकम",
  frozen: "फ्रोजन",
  transferred: "स्थानान्तरण गरिएको",
  voucher_balance: "भाउचर ब्यालेन्स",
  adjust_voucher_balance: "भाउचर ब्यालेन्स समायोजन गर्नुहोस्",
  free_game_provider: "निःशुल्क खेल प्रदायक",
  check_free_spin: "फ्री स्पिन जाँच गर्नुहोस्",
  freespin_log: "फ्री स्पिन लग",
  current_round: "हालको राउन्ड",
  lines: "लाइनहरू",
  expiry_interval_days: "म्याद समाप्ति अन्तराल (दिन)",
  assign: "तोक्नुहोस्",
  game_code: "गेम कोड",
  clear_free_credit: "फ्री क्रेडिट खाली गर्नुहोस्",
  deposit_tier: "जम्मा स्तर",
  point: "अंक",
  top: "माथि",
  bottom: "तल",
  leaderboard_banner: "लीडरबोर्ड ब्यानर",
  referral_banner: "रेफरल ब्यानर",
  tp_site: "ट्राफिक पूल URL",
  current_icon: "हालको आइकन",
  new_icon: "नयाँ आइकन",
  voucher_redeemed: "भाउचर रिडिम गरियो",
  on_site: "साइटमा",
  exclude_own: "आफ्नो बाहेक",
  voucher_redeemed_detail: "रिडिम गरिएको भाउचर विवरण",
  gamification: "गेमिफिकेशन",
  reward_rain: "Reward Rain",
  total_claimed_amount: "कुल दाबी गरिएको रकम",
  min_amount: "न्यूनतम रकम",
  max_amount: "अधिकतम रकम",
  reward_rain_session: "Reward Rain सेसन",
  reward_rain_session_claim: "Reward Rain सेसन दाबी",
  reward_amount: "पुरस्कार रकम",
  cta: "CTA",
  api_email: "API इमेल",
  api_password: "API पासवर्ड",
  url_callback_voucher: "भाउचर Callback URL",
  prefix_voucher: "भाउचर उपसर्ग",
  slide_show: "स्लाइड शो",
  ewallet_withdrawal: "ई-वॉलेट निकासी",
  news: "समाचार",
  slug: "स्लग",
  preview_body: "सामग्री पूर्वावलोकन",
  full_body: "पूर्ण सामग्री",
  normal: "सामान्य",
  free_balance: "निःशुल्क ब्यालेन्स",
  schema: "स्किमा",

  tt_pixel_id: "TT पिक्सेल आईडी",
  tt_token: "TT टोकन",

  free_spin_bulk_issue : "फ्री स्पिन (थोक जारी)",
}